import { render, staticRenderFns } from "./incidentReportProofAction.vue?vue&type=template&id=3a18b055"
import script from "./incidentReportProofAction.vue?vue&type=script&lang=js"
export * from "./incidentReportProofAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports